<ui-expander class="secondary" [badge]="productsToSelect().length" title="Auswahl erforderlich">
  <div class="wrapper-product-selection">
    @for (itemGroup of productsToSelect(); track itemGroup.key; let last = $last) {
      @let currentGroup = selectionGroups()[itemGroup.key];

      <div class="wrapper-group">
        <span class="key">{{ itemGroup.key }}</span>

        <div class="products-to-choose-group">
          @for (item of itemGroup.items; track item.sku) {
            <ui-shopping-list-item
              [showCheckbox]="true"
              [selected]="currentGroup?.includes(item.sku) ?? false"
              (selectedChange)="selectionChanged(itemGroup.key,item.sku,$event)"
              (quantityChanged)="item.quantity = $event.quantity"
              (removed)="removeProductFromGroup(itemGroup.key,item.sku)"
              [product]="item.productData"
              [shoppingListItem]="item">
            </ui-shopping-list-item>
          }
        </div>

        <ui-button
          [disabled]="!currentGroup?.length"
          (clicked)="emitProductsSelected(itemGroup)"
          buttonStyle="outlined">zur Liste hinzufügen
        </ui-button>

        @if (!last) {
          <hr>
        }
      </div>
    }
  </div>
</ui-expander>
